import FileInput from './FileInput.js';
export { default } from './FileInput.js';
//# sourceMappingURL=index.js.map
